import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { Device } from 'DeviceUtils';
import { ActivityIndicator, SplashScreen } from 'LocalGluons';

import defaultStyles from './InitialScreen.jss';

const InitialScreen = ({ showSplash }) =>
    showSplash ? (
        <SplashScreen />
    ) : (
        <View style={{ flex: 1, height: '100%', width: '100%', backgroundColor: 'black' }}>
            {/* Renders fake header to prevent loading indicator to jump after navigation is initialized */}
            {/* {!Device.isWeb && <View style={defaultStyles.header} />} */}
            <ActivityIndicator isOverlay={Device.isWeb} />
        </View>
    );

InitialScreen.defaultProps = {
    showSplash: true
};

InitialScreen.propTypes = {
    showSplash: PropTypes.bool
};

export default InitialScreen;
